import { SearchResponse } from 'api/Responses/SearchResponses';
import axiosInstance from 'services/APIService';

const ENDPOINT_PATH = `/v1/sets/search`;

const search = async (query: string, tenant_name: string): Promise<SearchResponse> => {
  let baseUrl = `${ENDPOINT_PATH}/${query}`;

  if (tenant_name) {
    baseUrl += `?tenant_name=${tenant_name}`;
  }

  const response = await axiosInstance.get<SearchResponse>(baseUrl);
  return response.data;
};

export default search;
